import { Link, useLocation } from 'react-router-dom';
import SVGIcon from '../../atoms/icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const Breadcrumb = () => {
	const { t } = useTranslation();
	const location = useLocation();

	// Obtém os caminhos a partir da URL atual
	const pathnames = location.pathname.split('/').filter((x) => x);

	// Gera o título baseado na posição do caminho
	const getTitle = (value: string, index: number) => {
		if (index === 0) return `${value}.title`;
		return `${pathnames.join('.').replace('-', '_')}.title`;
	};

	return (
		<nav className="px-6 py-3" aria-label="breadcrumb">
			<ol className="flex items-center gap-3">
				{/* Ícone de Home */}
				<li>
					<Link to="/" title={t('home.title')}>
						<SVGIcon
							className="fill-primary h-4 w-auto"
							icon="Home"
						/>
					</Link>
				</li>

				{/* Itens de navegação */}
				{pathnames.map((value, index) => {
					const to = `/${pathnames.slice(0, index + 1).join('/')}`;
					const isLast = index === pathnames.length - 1;

					return (
						<li
							className="flex items-center gap-2"
							key={to}
							aria-current={isLast ? 'page' : undefined}
						>
							{/* Ícone de separador */}
							<SVGIcon
								className="w-3 h-auto fill-primary-light"
								icon="Arrow"
								direction="right"
							/>

							{/* Link do breadcrumb */}
							<Link
								to={to}
								className={classNames('transition-colors', {
									'font-bold text-primary': !isLast,
									'text-gray-label pointer-events-none':
										isLast,
								})}
							>
								{t(getTitle(value, index))}
							</Link>
						</li>
					);
				})}
			</ol>
		</nav>
	);
};

export default Breadcrumb;
